import React from 'react';
import { findDOMNode } from 'react-dom';
import { DropTarget } from 'react-dnd';
import ItemTypes from '../../ItemTypes.js';


//import Wrapper from './BuilderWrapper.js';


/**
 * Specifies the drop target contract.
 * All methods are optional.
 */
const chessSquareTarget = {
    canDrop(props, monitor) {
        const item = monitor.getItemType();
        return true;
    },

    hover(props, monitor, component) {
        //
        //
    },

    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            return;
        }
        return;
        
        return;
        const item = monitor.getItem();
        //  console.log('DROP');
        // 

        let el = {};
        el.rowId = component.props.row.index;
        el.colId = component.props.colId;
        el.type = 'text';

     //   

        component.props.addElement(el);

    }
};

/**
 * Specifies which props to inject into your component.
 */
function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
}


class DroppableElement extends React.Component{
    constructor(props) {
        super(props);
    }
    componentWillReceiveProps(nextProps) {
        if (!this.props.isOver && nextProps.isOver) {
            // You can use this as enter handler
           // console.log('1');
        }

        if (this.props.isOver && !nextProps.isOver) {
            // You can use this as leave handler
           // console.log('2');
        }

        if (this.props.isOverCurrent && !nextProps.isOverCurrent) {
            // You can be more specific and track enter/leave
            // shallowly, not including nested targets
           // console.log('3');
        }
    }

    renderPlaceholder(child) {
        const { isOver, canDrop, connectDropTarget } = this.props;

        let elementsToRender = []; 


        //if(!isOver && canDrop) {
        if(isOver && canDrop) {
            elementsToRender.push(<div key="a" className="drop-placeholder">Drop here ty</div>);
        }else{
            elementsToRender.push(React.cloneElement(child, child.props));
        }

        return elementsToRender;
    }

    render() {
        // Your component receives its own props as usual
        const { position } = this.props;

        let classes = "";
        if(this.props.classes) {
            classes = this.props.classes;
        }

        let styles = {};
        if(this.props.styles) {
            styles = this.props.styles;
        }

        //

        // These props are injected by React DnD,
        // as defined by your `collect` function above:
        const { isOver, canDrop, connectDropTarget } = this.props;

        return connectDropTarget(
            <this.props.type style={styles} className={classes}>
                {this.props.children}
            </this.props.type>
            
        );
    }
}

export default DropTarget((props) => {return ItemTypes.CARD}, chessSquareTarget, collect)(DroppableElement);


// WEBPACK FOOTER //
// ./components/builder/DroppableElement.js